import { options } from '../config/options';
import { rgIDs } from '../../shared/constants/domIDs';
import { compactV2URLs } from '../../shared/constants/urls';

window.RGCompactComponent = window.zoid.create({
  ...options,
  tag: rgIDs.featureIcons,
  url: compactV2URLs,
  props: {
    ...options.props,
    onDispatchTriggerAttributes: {
      type: 'function',
      required: true,
    },
  },
});
